import { BlockerFunction, useBlocker } from 'react-router-dom';
import { Action } from 'history';
import { Location } from 'react-router-dom';

/**
 * Prompts the user with an Alert before they leave the current screen.
 *
 * @param  cb a callback function to determine if we should proceed with navigating to the route
 * @param  block the navigation should be blocked
 */
export function usePrompt(cb: (route: Location, action: Action) => boolean, block: boolean = true) {  
  const blocker: BlockerFunction =
    (tx) => {
      if (block) {
        return cb(tx.nextLocation, tx.historyAction);
      }
      return false;
    };

  useBlocker(blocker);
}
